import {type CopilotChatModel, CopilotPlan} from './copilot-chat-types'
import {copilotFeatureFlags} from './copilot-feature-flags'

export const AUTO_MODEL_ID = 'auto'

/**
 * Returns true when Auto Mode should be active for this user (Free/EDU + flag on).
 */
export function isAutoModeForFreeEdu(plan: CopilotPlan | undefined | null): boolean {
  if (!copilotFeatureFlags.autoModePickerFreeEdu) return false
  return plan === CopilotPlan.IndividualFree || plan === CopilotPlan.IndividualStudent
}

/**
 * Singleton Auto model pseudo-entry. Returns the same object reference every
 * call so hooks like useDefaultModel don't trigger re-renders.
 *
 * Most capability fields just satisfy the CopilotChatModel TypeScript interface —
 * they aren't consumed by UI logic for the Auto entry since CAPI handles routing.
 */
const AUTO_MODEL: CopilotChatModel = {
  id: AUTO_MODEL_ID,
  name: 'Auto',
  displayName: 'Auto',
  version: AUTO_MODEL_ID,
  vendor: 'GitHub',
  preview: false,
  // eslint-disable-next-line camelcase
  model_picker_enabled: true,
  hasLimitedCapabilities: false,
  isThirdParty: false,
  capabilities: {
    family: AUTO_MODEL_ID,
    // eslint-disable-next-line camelcase
    limits: {max_prompt_tokens: 128000},
    supports: {
      // eslint-disable-next-line camelcase
      tool_calls: true,
      streaming: true,
      vision: true,
    },
    tokenizer: 'o200k_base',
    type: 'chat',
  },
  billing: {
    // eslint-disable-next-line camelcase
    is_premium: false,
    multiplier: 0,
  },
}

export function getAutoModel(): CopilotChatModel {
  return AUTO_MODEL
}
